import { render } from "./FindPasswordPage.vue?vue&type=template&id=17079502&scoped=true"
import script from "./FindPasswordPage.vue?vue&type=script&lang=js"
export * from "./FindPasswordPage.vue?vue&type=script&lang=js"

import "./FindPasswordPage.vue?vue&type=style&index=0&id=17079502&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17079502"]])

export default __exports__